import { Component, OnInit, Input } from '@angular/core';



@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})

export class ForgotPasswordComponent implements OnInit {
  isConfirmPasswordExists : boolean;
  constructor() { }

  ngOnInit() {
  }  
}
